import { axiosPath } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    clone_config_path: {
      rider_status: 1,
      rider_id: 0,
      datetime_start: null,
      datetime_end: null
    },
    config_path: {
      rider_status: 1,
      rider_id: 0,
      datetime_start: null,
      datetime_end: null
    },
    rider_report_summary: {},
    rider_report_list: [],
    export_rider_format: [],
    servicesData: []
  },
  mutations: {
    resetState(state) {
      state.clone_config_path = {
        rider_status: 1,
        rider_id: 0,
        datetime_start: null,
        datetime_end: null
      };
      state.config_path = {
        rider_status: 1,
        rider_id: 0,
        datetime_start: null,
        datetime_end: null
      };
      state.rider_report_summary = {};
      state.rider_report_list = [];
      state.export_rider_format = [];
      state.servicesData = [];
    },
    getReportRiderList(state, data) {
      state.rider_report_list = data;
      let count_no = 1;
      for (let val of state.rider_report_list) {
        val.no = count_no++;
        val.no_default = count_no - 1;
      }
    },
    getReportRiderSummary(state, data) {
      state.rider_report_summary = data;
    },
    getExportReportRiderList(state) {
      state.export_rider_format = [];
      for (let val of state.rider_report_list) {
        let count_service_list = [];
        let service_comma_list = "";
        if (typeof val["serviceFood/Mes/Free"] == "string") {
          count_service_list = val["serviceFood/Mes/Free"].split("/");
        }
        for (let i in count_service_list) {
          service_comma_list = service_comma_list + count_service_list[i];
          if (i < count_service_list.length - 1) {
            service_comma_list = service_comma_list + ",";
          }
        }
        let index = state.rider_report_list.indexOf(val);
        let push_data = {
          No: index + 1,
          status: val.status,
          rider_name: val.rider_name,
          rider_time_start: val.rider_time_start,
          rider_tel: val.rider_tel,
          serviceFoodMesFree: service_comma_list,
          revenue: val.revenue
            ? parseFloat(val.revenue)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          com: val.com
            ? parseFloat(val.com)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          net_revenue: val.net_revenue
            ? parseFloat(val.net_revenue)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          credit: val.credit
            ? parseFloat(val.credit)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          tax_com: val.tax_com
            ? parseFloat(val.tax_com)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00"
        };
        state.export_rider_format.push(push_data);
      }
    },
    getExportSummary(state) {
      if (state.export_rider_format.length > 0) {
        let push_data = {
          rider_name: "Total",
          com: state.rider_report_summary.com
            ? parseFloat(state.rider_report_summary.com)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          credit: state.rider_report_summary.credit
            ? parseFloat(state.rider_report_summary.credit)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          net_revenue: state.rider_report_summary.net_revenue
            ? parseFloat(state.rider_report_summary.net_revenue)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          revenue: state.rider_report_summary.revenue
            ? parseFloat(state.rider_report_summary.revenue)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          serviceFoodMes: state.rider_report_summary["serviceFood/Mes"],
          tax_com: state.rider_report_summary.tax_com
            ? parseFloat(state.rider_report_summary.tax_com)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00"
        };
        state.export_rider_format.push(push_data);
      }
    },
    cloneConfigPath(state) {
      state.clone_config_path = JSON.parse(JSON.stringify(state.config_path));
    }
  },
  actions: {
    async getReportRiderList(
      { rootState, commit, state, dispatch },
      config_path
    ) {
      let url =
        rootState.api_urls.fetchRiderReport_getReportRiderList +
        config_path.rider_status +
        "/" +
        config_path.rider_id +
        "/" +
        config_path.datetime_start +
        "/" +
        config_path.datetime_end;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("getReportRiderSummary", res.calculate);
        commit("getReportRiderList", res.data);
        commit("getExportReportRiderList");
        commit("getExportSummary");
        commit("cloneConfigPath");
        return res;
      }
    }
  },
  getters: {}
};
